import { z } from 'zod';

export const BlockLayoutSchema = z.object({
  x: z.number(),
  y: z.number(),
  width: z.number().min(1),
  height: z.number().min(1),
  zIndex: z.number().int(),
  rotation: z.number().optional(),
});

export const BlockStrokeSchema = z.object({
  color: z.string(),
  width: z.number().min(0),
  style: z.enum(['solid', 'dashed', 'dotted', 'double']).optional(),
});

const TimerDurationSchema = z.object({
  hours: z.number().min(0),
  minutes: z.number().min(0).max(59),
  seconds: z.number().min(0).max(59),
});

export const CutdownCardBlockDataSchema = z.object({
  date: z.string().optional(),
  layout: z.enum(['horizontal', 'vertical']).optional(),
  units: z
    .array(z.enum(['days', 'hours', 'minutes', 'seconds']))
    .optional(),
  backgroundColor: z.string().optional(),
  stroke: BlockStrokeSchema.optional(),
  numberColor: z.string().optional(),
  labelColor: z.string().optional(),
  borderRadius: z.number().optional(),
  cardSize: z.number().optional(),
  gap: z.number().optional(),
  scale: z.number().optional(),
  animate: z.boolean().optional(),
});

export const TimerBlockDataSchema = z.object({
  defaultTarget: TimerDurationSchema.optional(),
  mode: z.enum(['countDown', 'countUp']).optional(),
  size: z.number().min(80).optional(),
});

export const CutdownCardBlockSchema = z.object({
  id: z.string(),
  type: z.literal('cutdown-card'),
  name: z.string().optional(),
  layout: BlockLayoutSchema,
  data: CutdownCardBlockDataSchema,
});

export const TimerBlockSchema = z.object({
  id: z.string(),
  type: z.literal('timer'),
  name: z.string().optional(),
  layout: BlockLayoutSchema,
  data: TimerBlockDataSchema,
});

export const BlockSchema = z.discriminatedUnion('type', [
  CutdownCardBlockSchema,
  TimerBlockSchema,
]);
